var LocalPager = (function () {
    function LocalPager() {
    }
    LocalPager.paginate = function (data, page, perPage) {
        return data.slice(perPage * (page - 1), perPage * page);
    };
    return LocalPager;
}());
export { LocalPager };
//# sourceMappingURL=local.pager.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-smart-table/lib/data-source/local/local.pager.js
// module id = 414
// module chunks = 3